import React, { useEffect, useMemo, useState } from "react";
import {
  useLocation,
  useNavigate,
  useParams,
  useSearchParams,
} from "react-router-dom";
import styled from "styled-components";

import PCContainer from "../../components/atoms/layout/pcContainer";
import LSRgDisplay02 from "../../components/molecules/text/linSeedKr/Rg/lsRgDisplay02";
import LSRgH2HeadLine from "./../../components/molecules/text/linSeedKr/Rg/lsRgH2HeadLine";
import Pagination from "../../components/molecules/pagination";
import LSRgBody01 from "./../../components/molecules/text/linSeedKr/Rg/lsRgBody01";
import { consultingTabList } from "../../constant/consultingTabList";
import LSBdH1HeadLine from "../../components/molecules/text/linSeedKr/Bd/lsBdH1HeadLine";
import PretendardText from "../../components/atoms/text/pretendardText";
import LSRgBody02 from "../../components/molecules/text/linSeedKr/Rg/lsRgBody02";
import LSBdBody01 from "../../components/molecules/text/linSeedKr/Bd/lsBdBody01";
import LSBdDisplay02 from "../../components/molecules/text/linSeedKr/Bd/lsBdDisplay02";
import InputLabel from "../../components/atoms/input/inputLabel";
import InputField from "../../components/atoms/input/inputField";
import Checkbox from "./../../components/atoms/input/checkbox";
import PrimaryBtn from "./../../components/atoms/button/primaryBtn";
import MOContainer from "../../components/atoms/layout/moContainer";
import LSRgH1HeadLine from "./../../components/molecules/text/linSeedKr/Rg/lsRgH1HeadLine";
import SelectBox from "./../../components/organisms/SelectBox";
import LSRgCaption03 from "./../../components/molecules/text/linSeedKr/Rg/lsRgCaption03";
import LSBdCaption01 from "./../../components/molecules/text/linSeedKr/Bd/lsBdCaption01";

import useDisplay from "../../hooks/useDisplay";
import { route } from "./../../router/route";
import Empty from "../../components/molecules/empty";
import { errorHandler } from "../../util/errorHandler";
import ConsultingApi from "../../api/consulting.api";
import TermApi from "../../api/term.api";
import ConfirmModal from "../../components/templates/modals/confirmModal";
import moment from "moment";
import { toast } from "react-toastify";
import LectureApi from "../../api/lecture.api";
import StyledCategoryItem from "../../components/molecules/button/styledCategoryItem";
import { macOSCheck } from "../../util/macOSCheck";

const ConsultingPrior = () => {
  const navigate = useNavigate();
  const { isMobile, isTablet, isDesktop } = useDisplay();
  const isSmall = isMobile || isTablet;

  const location = useLocation();
  const [searchParams, setSearchParams] = useSearchParams(); // eslint-disable-line no-unused-vars

  const [postList, setPostList] = useState([]);
  const [consultingTab, setIsConsultingTab] = useState([]);

  const page = useMemo(() => {
    const requestedPage = Number(searchParams.get("page"));
    return Number.isInteger(requestedPage) && requestedPage > 0
      ? requestedPage
      : 1;
  }, [searchParams]);

  const [pagination, setPagination] = useState({
    size: 5, // 한 페이지에 표시될 게시글 수
    rangeSize: 5, // 하단 페이지 사이즈
    totalCount: 0,
    totalPages: 0,
    first: false,
    last: false,
  });

  const [subMenuBoxOpen, setSubMenuBoxOpen] = useState(false);
  const [selectedSubMenu, setSelectedSubMenu] = useState(
    consultingTabList[1].title,
  );
  const [btnDisabled, setBtnDisabled] = useState(true);

  const [name, setName] = useState("");
  const [nameErrorM, setNameErrorM] = useState("");
  const [phone, setPhone] = useState("");
  const [phoneErrorM, setPhoneErrorM] = useState("");
  const [birth, setBirth] = useState("");
  const [birthErrorM, setBirthErrorM] = useState("");

  const [currentStatus, setCurrentStatus] = useState("");
  const [currentStatusErrorM, setCurrentStatusErrorM] = useState("");
  const [necessaryPart, setNecessaryPart] = useState("");
  const [necessaryPartErrorM, setNecessaryPartErrorM] = useState("");
  const [curiousPoint, setCuriousPoint] = useState("");
  const [curiousPointErrorM, setCuriousPointErrorM] = useState("");

  const [agree01, setAgree01] = useState(false);

  const [isPreConsulting, setIsPreConsulting] = useState(false);
  const [isCompleteModal, setIsCompleteModal] = useState(false);
  const [isPreCheckModal, setIsPreCheckModal] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    if (
      agree01 &&
      name &&
      nameErrorM === "" &&
      phone &&
      phoneErrorM === "" &&
      birth &&
      birthErrorM === "" &&
      currentStatus &&
      currentStatusErrorM === "" &&
      necessaryPart &&
      necessaryPartErrorM === "" &&
      curiousPoint &&
      curiousPointErrorM === ""
    ) {
      setBtnDisabled(false);
    } else {
      setBtnDisabled(true);
    }
  }, [
    agree01,
    name,
    nameErrorM,
    phone,
    phoneErrorM,
    birth,
    birthErrorM,
    currentStatus,
    currentStatusErrorM,
    necessaryPart,
    necessaryPartErrorM,
    curiousPoint,
    curiousPointErrorM,
  ]);

  useEffect(() => {
    if (phone.length > 0) {
      const regex = /^01[016789]\d{7,8}$/;
      if (!regex.test(phone)) {
        return setPhoneErrorM("휴대전화 번호를 정확히 입력해주세요.");
      }

      setPhoneErrorM("");
    }
  }, [phone]);

  useEffect(() => {
    if (birth.length > 0) {
      const regex = /^(19|20)\d{2}(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])$/;
      const year = Number(birth.slice(0, 4));
      const month = Number(birth.slice(4, 6));
      const day = Number(birth.slice(6, 8));
      const date = new Date(year, month - 1, day);
      if (
        !regex.test(birth) ||
        date.getFullYear() !== year ||
        date.getMonth() !== month - 1 ||
        date.getDate() !== day ||
        date > new Date()
      ) {
        return setBirthErrorM("생년월일이 올바르지 않습니다.");
      }

      setBirthErrorM("");
    }
  }, [birth]);

  useEffect(() => {
    if (sessionStorage.getItem("isLogin") !== "true") return;
    dataListFunc();
  }, [location]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (sessionStorage.getItem("isLogin") !== "true") {
      toast("사전 상담을 신청하려면 로그인을 해주세요.");
      navigate(route.login, {
        replace: true,
        state: { path: window.location.href },
      });
      return;
    }

    getTermData();
    isConsultingCheckFunc();
    consultingListFunc();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const consultingListFunc = async () => {
    try {
      const data = {
        page: 1,
        size: 1,
        lectureVideoFlag: "Inactive",
      };
      const response = (await LectureApi.getMemberList(data)).data.data.content;

      if (response && response.length > 0) {
        setIsConsultingTab(consultingTabList);
      } else {
        setIsConsultingTab([
          { title: "1:1 컨설팅이란?", path: route.consulting },
          { title: "사전 상담 받기", path: route.consulting_prior },
          { title: "신청하기", path: route.consulting_apply },
        ]);
      }
    } catch (error) {
      errorHandler(error);
    }
  };

  const [termData, setTermData] = useState({});

  const getTermData = async () => {
    try {
      const response = (await TermApi.getDetail(8)).data.data.content;

      setTermData(response);
    } catch (error) {
      console.error(error);
    }
  };

  const isConsultingCheckFunc = async () => {
    try {
      const data = {
        page: 1,
        size: 0,
        consultingStatus: "READY",
      };

      const response = (await ConsultingApi.getMyConsultingList(data)).data
        .data;

      if (response && response?.totalCount > 0) {
        setIsPreConsulting(true);
      } else {
        setIsPreConsulting(false);
      }
    } catch (error) {
      errorHandler(error);
    }
  };

  const dataListFunc = async () => {
    try {
      const data = {
        page: page,
        size: pagination.size,
      };

      const response = (await ConsultingApi.getMyConsultingList(data)).data
        .data;

      setPostList(response.content ?? []);
      setPagination((prev) => ({
        ...prev,
        totalCount: response.totalCount,
        totalPages: Math.ceil(response.totalCount / prev.size),
      }));
    } catch (error) {
      errorHandler(error);
    }
  };

  const addMyConsultingFunc = async () => {
    if (isSubmitting) return;
    setIsSubmitting(true);
    try {
      const data = {
        name: name,
        birth: birth,
        phoneNumber: phone,
        currentStatus: currentStatus,
        necessaryPart: necessaryPart,
        curiousPoint: curiousPoint,
      };

      await ConsultingApi.addMyConsulting(data);
      await dataListFunc();
      await isConsultingCheckFunc();

      setName("");
      setPhone("");
      setBirth("");
      setCurrentStatus("");
      setNecessaryPart("");
      setCuriousPoint("");
      setAgree01(false);

      setIsCompleteModal(true);
    } catch (error) {
      errorHandler(error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <HomeSection $isSmall={isSmall}>
      {isDesktop && (
        <PCContainer
          style={{
            flexDirection: "column",
            width: "100%",
          }}
        >
          <LSRgDisplay02
            style={{
              marginBottom: 32,
            }}
          >
            📋 1:1 컨설팅
          </LSRgDisplay02>
          <div
            style={{
              display: "flex",
              width: "100%",
              height: "fit-content",
              gap: 30,
            }}
          >
            {/* 탭 영역 */}
            <TabContainer>
              {consultingTab.map((tab, index) => (
                <StyledCategoryItem
                  key={index}
                  onClick={() => navigate(tab.path)}
                  isActive={index === 1 ? true : false}
                  title={tab.title}
                />
              ))}
            </TabContainer>
            {/* 본문 영역 */}
            <ContentContainer>
              <ContentWrapper>
                <LSBdDisplay02 style={{ color: "#101113" }}>
                  사전 상담 신청
                </LSBdDisplay02>

                <InputContainer>
                  <InputLabel
                    style={{
                      width: 447,
                    }}
                  >
                    <InputTitleWrapper>
                      <LSBdH1HeadLine style={{ color: "#101113" }}>
                        이름
                      </LSBdH1HeadLine>
                      <InputTitleRequiredDot />
                    </InputTitleWrapper>
                    <InputField
                      id="name"
                      name="name"
                      placeholder="이름을 입력해 주세요."
                      type="text"
                      autoComplete="off"
                      required={true}
                      value={name}
                      isWarring={nameErrorM !== ""}
                      warringMsg={nameErrorM}
                      onChange={(e) => {
                        setName(e.target.value);
                      }}
                    />
                  </InputLabel>

                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                    }}
                  >
                    <InputLabel
                      style={{
                        width: 447,
                      }}
                    >
                      <InputTitleWrapper>
                        <LSBdH1HeadLine style={{ color: "#101113" }}>
                          연락처
                        </LSBdH1HeadLine>
                        <InputTitleRequiredDot />
                      </InputTitleWrapper>
                      <InputField
                        id="phoneNumber"
                        name="phoneNumber"
                        placeholder="전화번호를 입력해 주세요."
                        type="text"
                        autoComplete="off"
                        required={true}
                        value={phone}
                        isWarring={phoneErrorM !== ""}
                        warringMsg={phoneErrorM}
                        onChange={(e) => {
                          setPhone(e.target.value);
                        }}
                        maxLength={11}
                      />
                    </InputLabel>
                    <InputLabel
                      style={{
                        width: 447,
                      }}
                    >
                      <InputTitleWrapper>
                        <LSBdH1HeadLine style={{ color: "#101113" }}>
                          생년월일
                        </LSBdH1HeadLine>
                        <InputTitleRequiredDot />
                      </InputTitleWrapper>
                      <InputField
                        id="birth"
                        name="birth"
                        placeholder="YYYYMMDD"
                        type="text"
                        autoComplete="off"
                        required={true}
                        value={birth}
                        isWarring={birthErrorM !== ""}
                        warringMsg={birthErrorM}
                        onChange={(e) => {
                          setBirth(e.target.value);
                        }}
                        maxLength={8}
                      />
                    </InputLabel>
                  </div>
                  <InputLabel>
                    <InputTitleWrapper>
                      <LSBdH1HeadLine style={{ color: "#101113" }}>
                        현재 상황
                      </LSBdH1HeadLine>
                      <LSRgBody02 style={{ color: "#101113" }}>
                        (ex. 주택 수, 대출 현황, 소득 등)
                      </LSRgBody02>
                      <InputTitleRequiredDot />
                    </InputTitleWrapper>
                    <InputField
                      id="situation"
                      name="situation"
                      placeholder=""
                      type="text"
                      autoComplete="off"
                      required={true}
                      value={currentStatus}
                      isWarring={currentStatusErrorM !== ""}
                      warringMsg={currentStatusErrorM}
                      onChange={(e) => {
                        setCurrentStatus(e.target.value);
                      }}
                    />
                  </InputLabel>
                  <InputLabel>
                    <InputTitleWrapper>
                      <LSBdH1HeadLine style={{ color: "#101113" }}>
                        상담이 필요한 부분
                      </LSBdH1HeadLine>
                      <LSRgBody02 style={{ color: "#101113" }}>
                        (ex. 해결해야 하는 문제, 1:1 과외식으로 공부하고 싶은
                        부분)
                      </LSRgBody02>
                      <InputTitleRequiredDot />
                    </InputTitleWrapper>
                    <InputField
                      id="consulting"
                      name="consulting"
                      placeholder=""
                      type="text"
                      autoComplete="off"
                      required={true}
                      value={necessaryPart}
                      isWarring={necessaryPartErrorM !== ""}
                      warringMsg={necessaryPartErrorM}
                      onChange={(e) => {
                        setNecessaryPart(e.target.value);
                      }}
                    />
                  </InputLabel>
                  <InputLabel>
                    <InputTitleWrapper>
                      <LSBdH1HeadLine style={{ color: "#101113" }}>
                        부동산 및 대출 관련 평소 궁금했던 점 3가지
                      </LSBdH1HeadLine>
                      <LSRgBody02 style={{ color: "#101113" }}>
                        (ex. 대출 신청하면 얼마만에 나오나요?, 사업자대출 받으면
                        용도증빙은 어떻게 하는 것인지?)
                      </LSRgBody02>
                      <InputTitleRequiredDot />
                    </InputTitleWrapper>
                    <InputField
                      id="consulting"
                      name="consulting"
                      placeholder=""
                      type="text"
                      autoComplete="off"
                      required={true}
                      value={curiousPoint}
                      isWarring={curiousPointErrorM !== ""}
                      warringMsg={curiousPointErrorM}
                      onChange={(e) => {
                        setCuriousPoint(e.target.value);
                      }}
                    />
                  </InputLabel>
                  <InputLabel>
                    <InputTitleWrapper>
                      <LSBdH1HeadLine style={{ color: "#101113" }}>
                        개인정보 수집 및 이용 동의(필수)
                      </LSBdH1HeadLine>
                      <InputTitleRequiredDot />
                    </InputTitleWrapper>
                    <AgreementContainer>
                      <AgreementWrapper className="custom-scrollbar">
                        <PretendardText
                          style={{
                            fontWeight: 400,
                            fontSize: 12,
                            lineHeight: "19.2px",
                            letterSpacing: "-0.6px",
                            color: "#A4A8B1",
                          }}
                        >
                          {termData?.content || ""}
                        </PretendardText>
                      </AgreementWrapper>
                    </AgreementContainer>
                    <Checkbox
                      id="privacyAgree"
                      name="privacyAgree"
                      checked={agree01}
                      value="Agree"
                      valueText="개인정보 수집 및 이용에 동의합니다."
                      onChange={() => {
                        setAgree01(!agree01);
                      }}
                      required={true}
                      style={{ marginTop: 6 }}
                    />
                  </InputLabel>
                </InputContainer>
                <SubmitBtnWrapper>
                  <PrimaryBtn
                    disabled={btnDisabled || isSubmitting}
                    btnText={isSubmitting ? "등록 중" : "문의하기"}
                    onClick={() => {
                      let isLogin = sessionStorage.getItem("isLogin");
                      if (isLogin === "true") {
                        if (isPreConsulting) {
                          setIsPreCheckModal(true);
                        } else {
                          addMyConsultingFunc();
                        }
                      } else {
                        toast("글쓰기를 위해 로그인을 해주세요.");
                        navigate(`${route.login}`, {
                          state: { path: window.location.href },
                        });
                      }
                    }}
                  />
                </SubmitBtnWrapper>
              </ContentWrapper>

              <TableWrapper>
                <ContentHeaderWrapper>
                  <LSRgDisplay02>나의 상담 내역</LSRgDisplay02>
                  <LSRgH2HeadLine>
                    이전 진행한 상담 내역을 확인하실 수 있습니다.
                  </LSRgH2HeadLine>
                </ContentHeaderWrapper>

                {/* 본문 영역 - 테이블 */}
                <Table>
                  <tbody>
                    {postList.length > 0 ? (
                      postList.map((item, index) => (
                        <Tr
                          key={index}
                          style={{
                            borderTop: !item.answerFlag && "1px solid #dbdde0",
                          }}
                        >
                          <td style={{ marginRight: 10 }}>
                            <AnswerStateBox
                              style={{
                                borderColor: !item.answerFlag
                                  ? "#5050FF"
                                  : "#A4A8B1",
                              }}
                            >
                              <LSBdBody01
                                style={{
                                  color: !item.answerFlag
                                    ? "#5050FF"
                                    : "#A4A8B1",
                                }}
                              >
                                {!item.answerFlag ? "상담대기" : "상담완료"}
                              </LSBdBody01>
                            </AnswerStateBox>
                          </td>
                          <td
                            style={{
                              marginRight: 110,
                            }}
                          >
                            <LSRgH2HeadLine
                              style={{
                                color: "#101113",
                                width: 488,
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                                cursor: "pointer",
                              }}
                              onClick={() => {
                                navigate(
                                  `${route.consulting_prior_detail}/${item.id}`,
                                );
                              }}
                            >
                              {item.necessaryPart}
                            </LSRgH2HeadLine>
                          </td>
                          <td
                            style={{
                              width: 145,
                              display: "flex",
                              alignItems: "center",
                              gap: 6,
                              marginRight: 57,
                            }}
                          >
                            <img
                              style={{
                                width: 18,
                                height: 18,
                                objectFit: "cover",
                              }}
                              src={"/assets/icons/user.png"}
                              alt={"작성자"}
                            />
                            <LSRgBody01
                              style={{
                                width: 121,
                                color: "#898E99",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                              }}
                            >
                              {item.member.nickname}
                            </LSRgBody01>
                          </td>
                          <td
                            style={{
                              display: "flex",
                              alignItems: "center",
                              width: 88,
                            }}
                          >
                            <LSRgBody01 style={{ color: "#898E99" }}>
                              {moment(item.createdAt).format("YYYY.MM.DD")}
                            </LSRgBody01>
                          </td>
                        </Tr>
                      ))
                    ) : (
                      <Empty title={"나의 상담 내역이 없습니다."} />
                    )}
                  </tbody>
                </Table>

                {postList.length > 0 && (
                  <Pagination
                    route={route.consulting_prior}
                    queryString={``}
                    currentPage={Number(page) || 1}
                    totalPages={pagination.totalPages}
                    rangeSize={pagination.rangeSize}
                  />
                )}
              </TableWrapper>
            </ContentContainer>
          </div>
        </PCContainer>
      )}

      {/* ******************************** */}
      {/* ********** 모바일 버전 ********** */}
      {/* ******************************** */}
      {isSmall && (
        <MOContainer>
          <ContentContainer $isSmall={isSmall}>
            <ContentHeaderWrapper $isSmall={isSmall}>
              <LSRgH1HeadLine>📋 1:1 컨설팅</LSRgH1HeadLine>
              <SelectBox
                style={{
                  width: "100%",
                }}
                subMenuStyle={{
                  width: "100%",
                }}
                isSmall={true}
                isOpen={subMenuBoxOpen}
                isLink={true}
                selectedValue={selectedSubMenu}
                wrapperHandler={() => {
                  setSubMenuBoxOpen(!subMenuBoxOpen);
                }}
                itemList={consultingTab}
                selectedValueSetterFunc={setSelectedSubMenu}
              />
            </ContentHeaderWrapper>

            <LSRgH1HeadLine>사전 상담 신청</LSRgH1HeadLine>
            <InputContainer $isSmall={isSmall}>
              <InputLabel>
                <InputTitleWrapper>
                  <LSBdH1HeadLine style={{ color: "#101113" }}>
                    이름
                  </LSBdH1HeadLine>
                  <InputTitleRequiredDot />
                </InputTitleWrapper>
                <InputField
                  id="name"
                  name="name"
                  placeholder="이름을 입력해 주세요."
                  type="text"
                  autoComplete="off"
                  required={true}
                  value={name}
                  isWarring={nameErrorM !== ""}
                  warringMsg={nameErrorM}
                  onChange={(e) => {
                    setName(e.target.value);
                  }}
                />
              </InputLabel>
              <InputLabel>
                <InputTitleWrapper>
                  <LSBdH1HeadLine style={{ color: "#101113" }}>
                    연락처
                  </LSBdH1HeadLine>
                  <InputTitleRequiredDot />
                </InputTitleWrapper>
                <InputField
                  id="phoneNumber"
                  name="phoneNumber"
                  placeholder="전화번호를 입력해 주세요."
                  type="text"
                  autoComplete="off"
                  required={true}
                  value={phone}
                  isWarring={phoneErrorM !== ""}
                  warringMsg={phoneErrorM}
                  onChange={(e) => {
                    setPhone(e.target.value);
                  }}
                  maxLength={11}
                />
              </InputLabel>
              <InputLabel>
                <InputTitleWrapper>
                  <LSBdH1HeadLine style={{ color: "#101113" }}>
                    생년월일
                  </LSBdH1HeadLine>
                  <InputTitleRequiredDot />
                </InputTitleWrapper>
                <InputField
                  id="birth"
                  name="birth"
                  placeholder="YYYYMMDD"
                  type="text"
                  autoComplete="off"
                  required={true}
                  value={birth}
                  isWarring={birthErrorM !== ""}
                  warringMsg={birthErrorM}
                  onChange={(e) => {
                    setBirth(e.target.value);
                  }}
                  maxLength={8}
                />
              </InputLabel>
              <InputLabel>
                <InputTitleWrapper>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                      gap: "2px",
                    }}
                  >
                    <LSBdH1HeadLine style={{ color: "#101113" }}>
                      현재 상황
                    </LSBdH1HeadLine>
                    <LSRgCaption03 style={{ color: "#101113" }}>
                      (ex. 주택 수, 대출 현황, 소득 등)
                    </LSRgCaption03>
                  </div>

                  <InputTitleRequiredDot />
                </InputTitleWrapper>
                <InputField
                  id="situation"
                  name="situation"
                  placeholder=""
                  type="text"
                  autoComplete="off"
                  required={true}
                  value={currentStatus}
                  isWarring={currentStatusErrorM !== ""}
                  warringMsg={currentStatusErrorM}
                  onChange={(e) => {
                    setCurrentStatus(e.target.value);
                  }}
                />
              </InputLabel>
              <InputLabel>
                <InputTitleWrapper>
                  <LSBdH1HeadLine style={{ color: "#101113" }}>
                    상담이 필요한 부분
                  </LSBdH1HeadLine>
                  <InputTitleRequiredDot />
                </InputTitleWrapper>
                <LSRgCaption03 style={{ color: "#101113" }}>
                  (ex. 해결해야 하는 문제, 1:1 과외식으로 공부하고 싶은 부분)
                </LSRgCaption03>
                <InputField
                  id="situation"
                  name="situation"
                  placeholder=""
                  type="text"
                  autoComplete="off"
                  required={true}
                  value={necessaryPart}
                  isWarring={necessaryPartErrorM !== ""}
                  warringMsg={necessaryPartErrorM}
                  onChange={(e) => {
                    setNecessaryPart(e.target.value);
                  }}
                />
              </InputLabel>
              <InputLabel>
                <InputTitleWrapper>
                  <LSBdH1HeadLine style={{ color: "#101113" }}>
                    부동산 및 대출 관련 평소 궁금했던 점 3가지
                  </LSBdH1HeadLine>
                  <InputTitleRequiredDot />
                </InputTitleWrapper>
                <LSRgCaption03 style={{ color: "#101113" }}>
                  (ex. 대출 신청하면 얼마만에 나오나요?, 사업자대출 받으면
                  용도증빙은 어떻게 하는 것인지?)
                </LSRgCaption03>
                <InputField
                  id="consulting"
                  name="consulting"
                  placeholder=""
                  type="text"
                  autoComplete="off"
                  required={true}
                  value={curiousPoint}
                  isWarring={curiousPointErrorM !== ""}
                  warringMsg={curiousPointErrorM}
                  onChange={(e) => {
                    setCuriousPoint(e.target.value);
                  }}
                />
              </InputLabel>
              <InputLabel>
                <InputTitleWrapper>
                  <LSBdH1HeadLine style={{ color: "#101113" }}>
                    개인정보 수집 및 이용 동의(필수)
                  </LSBdH1HeadLine>
                  <InputTitleRequiredDot />
                </InputTitleWrapper>
                <AgreementContainer>
                  <AgreementWrapper className="custom-scrollbar">
                    <PretendardText
                      style={{
                        fontWeight: 400,
                        fontSize: 12,
                        lineHeight: "19.2px",
                        letterSpacing: "-0.6px",
                        color: "#A4A8B1",
                      }}
                    >
                      {termData?.content || ""}
                    </PretendardText>
                  </AgreementWrapper>
                </AgreementContainer>
                <Checkbox
                  id="privacyAgree"
                  name="privacyAgree"
                  checked={agree01}
                  value="Agree"
                  valueText="개인정보 수집 및 이용에 동의합니다."
                  onChange={() => {
                    setAgree01(!agree01);
                  }}
                  required={true}
                  style={{ marginTop: 6 }}
                />
              </InputLabel>
              <SubmitBtnWrapper $isSmall={isSmall}>
                <PrimaryBtn
                  disabled={btnDisabled || isSubmitting}
                  btnText={isSubmitting ? "등록 중" : "문의하기"}
                  onClick={() => {
                    let isLogin = sessionStorage.getItem("isLogin");
                    if (isLogin === "true") {
                      if (isPreConsulting) {
                        setIsPreCheckModal(true);
                      } else {
                        addMyConsultingFunc();
                      }
                    } else {
                      toast("글쓰기를 위해 로그인을 해주세요.");
                      navigate(`${route.login}`, {
                        state: { path: window.location.href },
                      });
                    }
                  }}
                />
              </SubmitBtnWrapper>
            </InputContainer>

            <TableWrapper $isSmall={isSmall}>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: 4,
                  margin: "60px 0px 20px 0px",
                }}
              >
                <LSRgH1HeadLine>나의 상담 내역</LSRgH1HeadLine>
                <LSRgBody01>
                  이전 진행한 상담 내역을 확인하실 수 있습니다.
                </LSRgBody01>
              </div>

              {/* 본문 영역 - 테이블 */}
              <Table $isSmall={isSmall}>
                <tbody>
                  {postList.length > 0 ? (
                    postList.map((item, index) => (
                      <Tr
                        key={index}
                        $isSmall={isSmall}
                        style={{
                          borderTop: !item.answerFlag && "1px solid #dbdde0",
                        }}
                      >
                        <td
                          style={{
                            display: "flex",
                            width: 315,
                            flexDirection: "column",
                            gap: 10,
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              gap: 10,
                            }}
                          >
                            <AnswerStateBox
                              style={{
                                borderColor: !item.answerFlag
                                  ? "#5050FF"
                                  : "#A4A8B1",
                              }}
                            >
                              <LSBdCaption01
                                style={{
                                  color: !item.answerFlag
                                    ? "#5050FF"
                                    : "#A4A8B1",
                                }}
                              >
                                {!item.answerFlag ? "상담대기" : "상담완료"}
                              </LSBdCaption01>
                            </AnswerStateBox>
                            <LSRgBody01
                              style={{
                                maxWidth: 247,
                                display: "-webkit-box",
                                WebkitBoxOrient: "vertical",
                                wordBreak: "normal",
                                whiteSpace: "normal",
                                overflow: "hidden",
                                WebkitLineClamp: 2, // 2줄부터 ... 표시
                              }}
                              onClick={() => {
                                navigate(
                                  `${route.consulting_prior_detail}/${item.id}`,
                                );
                              }}
                            >
                              {item.necessaryPart}
                            </LSRgBody01>
                          </div>
                          <div
                            style={{
                              display: "flex",
                              paddingLeft: 68,
                              justifyContent: "flex-end",
                              alignItems: "center",
                              gap: 10,
                            }}
                          >
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: 6,
                              }}
                            >
                              <img
                                style={{
                                  width: 14,
                                  height: 14,
                                  objectFit: "cover",
                                }}
                                src={"/assets/icons/user.png"}
                                alt={"작성자"}
                              />
                              <LSRgBody01
                                style={{
                                  width: 86,
                                  color: "#898E99",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  whiteSpace: "nowrap",
                                }}
                              >
                                {item.member.nickname}
                              </LSRgBody01>
                            </div>
                            <LSRgBody01 style={{ width: 88, color: "#898E99" }}>
                              {moment(item.createdAt).format("YYYY.MM.DD")}
                            </LSRgBody01>
                          </div>
                        </td>
                      </Tr>
                    ))
                  ) : (
                    <Empty title={"나의 상담 내역이 없습니다."} />
                  )}
                </tbody>
              </Table>

              {postList.length > 0 && (
                <Pagination
                  route={route.consulting_prior}
                  queryString={``}
                  currentPage={Number(page) || 1}
                  totalPages={pagination.totalPages}
                  rangeSize={pagination.rangeSize}
                />
              )}
            </TableWrapper>
          </ContentContainer>
        </MOContainer>
      )}

      {isCompleteModal ? (
        <ConfirmModal
          isAlert={true}
          isScroll={false}
          title={"사전 상담 등록 완료!"}
          content={
            "사전 상담이 정상적으로 등록되었습니다.\n확인 후 답변 드리겠습니다."
          }
          onClick={() => {
            setIsCompleteModal(false);
          }}
          onYClick={() => {
            setIsCompleteModal(false);
          }}
        />
      ) : null}

      {isPreCheckModal ? (
        <ConfirmModal
          isScroll={false}
          title={"이미 신청한\n사전 상담 내용이 있어요."}
          content={"추가로 사전 상담을 신청하시겠습니까?"}
          onClick={() => {
            setIsPreCheckModal(false);
          }}
          onYClick={() => {
            setIsPreCheckModal(false);
            addMyConsultingFunc();
          }}
        />
      ) : null}
    </HomeSection>
  );
};

export default ConsultingPrior;

const HomeSection = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  padding: ${(props) =>
    props.$isSmall ? "40px 0px 80px 0px" : "80px 0px 150px 0px"};
`;

const TabContainer = styled.div.attrs((props) => {})`
  width: 175px;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const ContentContainer = styled.div.attrs((props) => {})`
  width: ${(props) => (props.$isSmall ? "335px" : "995px")};
  height: fit-content;
  display: flex;
  flex-direction: column;
  margin-bottom: ${(props) => (props.$isSmall ? "0px" : "150px")};
`;

const ContentWrapper = styled.div.attrs((props) => {})`
  display: flex;
  flex-direction: column;
  width: 995px;
  height: fit-content;
  box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.1);
  border-radius: 30px;
  padding: 60px 40px;
  margin-bottom: 60px;
`;

const ContentHeaderWrapper = styled.div.attrs((props) => {})`
  display: flex;
  flex-direction: column;
  gap: ${(props) => (props.$isSmall ? "16px" : "10px")};
  margin-bottom: ${(props) => (props.$isSmall ? "40px" : "30px")};
`;

const TableWrapper = styled.div.attrs((props) => {})`
  display: flex;
  flex-direction: column;
  width: ${(props) => (props.$isSmall ? "335px" : "995px")};
  height: fit-content;
`;

const Table = styled.table.attrs((props) => {})`
  width: ${(props) => (props.$isSmall ? "335px" : "995px")};
  border-spacing: 0px;
  border-collapse: collapse;
`;

const Tr = styled.tr.attrs((props) => {})`
  width: ${(props) => (props.$isSmall ? "335px" : "995px")};
  height: ${(props) => (props.$isSmall ? "96px" : "64px")};
  border-bottom: 1px solid #dbdde0;
  padding: 16px 10px;
  display: flex;
  align-items: center;
`;

const AnswerStateBox = styled.div.attrs((props) => {})`
  width: ${(props) => (props.$isSmall ? "58px" : "89px")};
  height: ${(props) => (props.$isSmall ? "fit-content" : "32px")};
  padding: ${(props) => (props.$isSmall ? "6px 12px" : "0px")};
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 30px;
  border: 1px solid;
`;

const InputContainer = styled.div.attrs((props) => {})`
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-top: ${(props) => (props.$isSmall ? "20px" : "32px")};
`;

const InputTitleWrapper = styled.div.attrs((props) => {})`
  padding-left: 5px;
  display: flex;
  gap: 2px;
`;

const InputTitleRequiredDot = styled.span.attrs((props) => {})`
  width: 4px;
  height: 4px;
  background-color: #f24147;
  border-radius: 50%;
`;

const AgreementContainer = styled.div.attrs((props) => {})`
  width: 100%;
  height: 125px;
  border: 1px solid #dbdde0;
  border-radius: 12px;
  padding: 15px;
  display: flex;
  flex-direction: column;
`;

const AgreementWrapper = styled.div.attrs((props) => {})`
  width: 100%;
  height: 95px;
  overflow-y: auto;
`;

const SubmitBtnWrapper = styled.div.attrs((props) => {})`
  display: flex;
  justify-content: center;
  align-items: center;
  height: fit-content;
  width: 100%;
  margin-top: ${(props) => (props.$isSmall ? "28px" : "50px")};
`;
